module.exports = __webpack_public_path__ + "static/portfolio-mas-14-18048ae08c0a75d1edf90e7cebc02c39.jpg";